import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const COOKIE_CONSENT_KEY = "shakatah-cookie-consent";

// NOTE: Using function declaration instead of const arrow to prevent TDZ errors in production builds
export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, [mounted]);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setIsVisible(false);
  };

  if (!mounted || !isVisible) return null;

  return (
    <div className="fixed inset-x-4 bottom-4 z-40 animate-in slide-in-from-bottom-5 duration-300 sm:left-4 sm:right-auto sm:max-w-md">
      <div className="relative rounded-2xl border border-border bg-card p-4 shadow-xl sm:p-5">
        <button
          onClick={handleDecline}
          className="absolute top-2 right-2 text-muted-foreground hover:text-foreground"
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-start gap-3 pr-6">
          <Cookie className="w-5 h-5 text-primary shrink-0 mt-0.5" />
          <div className="space-y-2">
            <p className="text-sm font-semibold text-foreground">We use cookies</p>
            <p className="text-xs leading-5 text-muted-foreground sm:text-sm">
              We use cookies to improve your experience, analyze traffic, and support core site features.{" "}
              <Link to="/privacy-policy" className="text-primary hover:underline">
                Learn more
              </Link>
            </p>
            <div className="flex flex-col gap-2 pt-1 sm:flex-row sm:items-center">
              <Button variant="outline" size="sm" onClick={handleDecline} className="h-9 px-4 text-xs sm:text-sm">
                Decline
              </Button>
              <Button size="sm" onClick={handleAccept} className="h-9 px-4 text-xs sm:text-sm">
                I Accept
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
